export default "__VITE_ASSET__BoYYFBCJ__"